import { Box, Skeleton } from '@mui/material'
import ListUserRoom from './ListUserRoom'

function ListParticipantsShareRoom({userListRender, setChangeDataParticipant, displayCloseIcon, t, addPeople = false, handleOpenModalShareSubtitles, hideAddButton=false, isChangePeriod=false, ...props}) {

  return (
    <div className="share-subtitle-content-participant" {...props}
      onClick={() => {
        if(userListRender.length === 0 && !isChangePeriod){
          handleOpenModalShareSubtitles()
        }
      }}
    >
      {
        ( userListRender) ?
        (
          (addPeople || userListRender?.length > 0 ) ?
          (
            <ListUserRoom 
              dataParticipants={userListRender} 
              setChangeDataParticipant={setChangeDataParticipant} 
              displayCloseIcon={displayCloseIcon}
              handleOpenModalShareSubtitles={handleOpenModalShareSubtitles}
              hideAddButton={hideAddButton}
              isChangePeriod={isChangePeriod}
            />
          ) 
          :
          (
            <Box sx={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>{t('subtitles.table.no-data')}</Box>
          )
        ) 
        :
        (
          <Box sx={{display: 'flex', width: '100%', flexDirection: 'column'}}>
              <Skeleton sx={{width: '80%', marginLeft: '10px'}}/>
              <Skeleton sx={{width: '80%', marginLeft: '10px'}}/>
              <Skeleton sx={{width: '80%', marginLeft: '10px'}}/>
          </Box>
        )
      }

      
    </div>
  )
}

export default ListParticipantsShareRoom